/**
 * The unified asset-status vocabulary the backend serializes for every RA
 * artifact (cohort / analytical variable / analytical dataset / concept group)
 * — the FE mirror of the Python ``AssetStatus`` enum
 * (``shared_types/artifact_status.py``), whose values are the human labels.
 *
 * Use these constants for the FE's status **comparisons / fallbacks** so the
 * branching logic isn't stringly-typed (a typo'd ``=== 'Procesing'`` compiles
 * fine and silently misbehaves).
 *
 * NOTE: this is intentionally NOT a strict wire enum. The wire fields that carry
 * it (e.g. cohort-profile ``assetStatus``) stay tolerant ``string`` at the parse
 * boundary, so a future backend status renders rather than soft-failing. This
 * union types the projected values + the comparison sites only.
 */
export const ASSET_STATUS = {
  DRAFT: 'Draft',
  PROCESSING: 'Processing',
  READY: 'Ready',
  ERROR: 'Error',
} as const;

export type AssetStatus = (typeof ASSET_STATUS)[keyof typeof ASSET_STATUS];
